// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3WUVb","signatureButtonsRight":"ModalSign_signatureButtonsRight__15e09"};